// driving_school_classroom_program_setup_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["durationChangeConfirmationPanel"];

  async showQuickLook(event) {
    event.preventDefault();

    const sessionId = this.data.get("sessionId");

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/schools/classroom/sessions/${sessionId}/quick-look`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    if (response.ok) {
      const quickViewElement =
        document.querySelector("#school-classrooms-quick-look") ||
        document.querySelector("#school_classrooms_quick_look");
      
      if (!quickViewElement) {
        console.error("Quick view element not found in the DOM.");
        return;
      }

      quickViewElement.classList.remove("u-hidden");

      const responseBody = await response.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseBody, "text/html");
      const template = xmlDoc.querySelector("template");

      if (template) {
        quickViewElement.innerHTML = "";
        quickViewElement.appendChild(template.content.cloneNode(true));
      }
    }
  }
  
  closeQuickLook(event) {
    event.preventDefault();
    
    const quickViewElement =
      document.querySelector("#school-classrooms-quick-look") ||
      document.querySelector("#school_classrooms_quick_look");

    if (!quickViewElement) {
      console.error("Quick view element not found in the DOM.");
      return;
    }

    quickViewElement.classList.add("u-hidden");
  }

  async showEnrollQuickLook(event) {
    event.preventDefault();

    const programId = this.data.get("programId");
    
    const quickViewElement = document.querySelector("#school-classrooms-quick-look");
    quickViewElement.classList.remove("u-hidden");
    
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/schools/classroom/program/${programId}/quick-look/enroll`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    if (response.ok) {

      const responseBody = await response.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseBody, "text/html");
      const template = xmlDoc.querySelector("template");
      const targetElement = document.getElementById("school-classrooms-quick-look");

      if (template && targetElement) {
        targetElement.innerHTML = "";
        targetElement.appendChild(template.content.cloneNode(true));
      }
    }
  }

  validate(event) {
    const errors = this.validateForm();
    
    if (errors.length > 0) {
      event.preventDefault();
      this.showValidationBlock(errors.join("<br>"));
      return;
    }    
  }

  validateForm() {
    let validationErrors = [];

    let fieldsToValidate = [
      { id: "driving_school_classroom_session_start_time", name: "Start time", validation: "required|datetime" }
    ];

    fieldsToValidate.forEach(field_data => {
      let field = document.getElementById(field_data.id);
      
      if (field) {
        let value = field.value;
        let validationRules = field_data.validation.split('|');
  
        for (let rule of validationRules) {
          switch (rule) {
            case 'required':
              if (!value) {
                validationErrors.push(`${field_data.name} is required.`);
                return;
              }
              break;
  
            case 'datetime':
              if (value && isNaN(Date.parse(value))) {
                validationErrors.push(`${field_data.name} must be a valid date-time.`);
                return;
              }
              break;
  
            case 'positiveNumber':
              if (value === "") {
                validationErrors.push(`${field_data.name} cannot be empty.`);
                return;
              } else if (isNaN(value) || Number(value) <= 0) {
                validationErrors.push(`${field_data.name} must be greater than 0.`);
                return;
              }
              break;
          }
        }
      } else {
        console.log(`Field with id ${field_data.id} not found.`);
      }
    });
    
    return validationErrors;
  }

  showValidationBlock(message) {
    const validationBlock = document.getElementById("validation-block");
    const validationMessage = document.getElementById("validation-message");
  
    validationMessage.innerHTML = message;
    validationBlock.hidden = false;
    validationMessage.hidden = false;
  }

  dismissDurationChangeConfirmationPanel(event) {
    event.preventDefault();
    const el = document.getElementById("session-duration-change-confirmation");
    if (el) el.replaceChildren();
    this._enableMainSessionSaveButton();
  }

  durationChangeConfirmationPanelTargetConnected(element) {
    this._disableMainSessionSaveButton();

    element.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }

  durationChangeConfirmationPanelTargetDisconnected() {
    this._enableMainSessionSaveButton();
  }

  _disableMainSessionSaveButton() {
    const btn = this._findMainSessionSaveButton();
    if (btn) {
      btn.disabled = true;
      btn.classList.add("Button--disabled");
    }
  }

  _enableMainSessionSaveButton() {
    const btn = this._findMainSessionSaveButton();
    if (btn) {
      btn.disabled = false;
      btn.classList.remove("Button--disabled");
    }
  }

  _findMainSessionSaveButton() {
    const forms = this.element.querySelectorAll("form");
    if (!forms.length) return null;

    const mainForm = forms[0];
    return mainForm.querySelector('button[type="submit"]');
  }
}
